import React from 'react';
import { Input } from 'rsuite';
import { Container, InputWrapper } from './style';
import { Label } from '../Label';
import './styles.css';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').InputProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomInputNumber({ label, ...rest }) {
  return (
    <Container>
      {Boolean(label) && <Label htmlFor={rest?.id}>{label}</Label>}
      <InputWrapper>
        <Input {...rest} type="number" className="custom-input" />
      </InputWrapper>
    </Container>
  );
}
